// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ov-8";
export var editMode = "_ov-3";
export var headerRow = "_ov-a";
export var headerTitle = "_ov-b";
export var product = "_ov-1";
export var productDetails = "_ov-5";
export var productDivider = "_ov-7";
export var productImage = "_ov-2";
export var productInfo = "_ov-4";
export var productTitle = "_ov-6";
export var strikethrough = "_ov-9";
export var upsellProductsCard = "_ov-0";